export const counsels = [
  { name: 'Medicina', initials: 'CRM' },
  { name: 'Odontologia', initials: 'CRO' },
];
